import { useMemo, useState, useEffect } from "react";

const useSidebar = (sidebarId, defaultOpen = false) => {
  const storageKey = useMemo(() => `WonderOrder.Sidebar.${sidebarId}`, [sidebarId]);

  // セッションストレージ（同一タブ）で管理している開閉状態を取り出す
  const initialOpen = useMemo(() => {
    const sidebarState = window.sessionStorage.getItem(storageKey);
    switch (sidebarState) {
      case "open":
        return true;
      case "close":
        return false;
    }
    return defaultOpen;
  }, [sidebarId]);

  const [sidebarOpen, setSidebarOpen] = useState(initialOpen);

  // 開閉状態が変わったらセッションストレージに記録
  useEffect(() => {
    window.sessionStorage.setItem(storageKey, sidebarOpen ? "open" : "close");
  }, [sidebarOpen]);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return { sidebarId, sidebarOpen, toggleSidebar };
};
export default useSidebar;